import { Button as MuiButton, DialogTitle as MuiDialogTitle, styled } from "@mui/material";

export const DialogTitle = styled(MuiDialogTitle)(
  ({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing(2)};
  svg {
    cursor: pointer;
  }
`,
);

export const Button = styled(MuiButton)(
  ({ theme }) => `
  background: ${theme.palette.primary.main};
  color: ${theme.palette.common.white};
  min-width: 100px;
  border-radius: 100px;
  margin-bottom: ${theme.spacing(4)};
  margin-top: ${theme.spacing(2)};  
`,
);
